/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Whether this Play uses generated content.
 *
 * - NONE: The Play has no generated content.
 * - OPTIONAL: The Play has content, but it is optional.
 * - CONTENT: The Play has required content
 */
export enum PlayContentMode {
    NONE = 'NONE',
    OPTIONAL = 'OPTIONAL',
    REQUIRED = 'REQUIRED',
}
